const downloadFileHandler = '__ua_Download_file_handler';
const pageEventsHandler = '__ua_Page_events_handler';
const shareFileHandler = '__ua_Share_file_handler';

declare global {
  interface Window {
    __ua_is_flutter_webview?: boolean;
    __ua_is_rn_webview?: boolean;
    flutter_inappwebview: {
      callHandler: (handler: string, ...args: unknown[]) => Promise<unknown>;
    };
    ReactNativeWebView: {
      postMessage: (message: string) => void;
    };
  }
}

export const isFlutterWebView = () => {
  return typeof window !== 'undefined' && window.__ua_is_flutter_webview;
};

export const isReactNativeWebView = () => {
  return typeof window !== 'undefined' && window.__ua_is_rn_webview;
};

export const isFlutterFnNotImplemented = () => {
  return !isFlutterWebView() && typeof window !== 'undefined' && window.flutter_inappwebview;
};

export const isReactNativeFnNotImplemented = () => {
  return !isReactNativeWebView() && typeof window !== 'undefined' && window.ReactNativeWebView;
};

export const isWebview = () => {
  return isFlutterWebView() || isReactNativeWebView();
};

export const downloadFileInWebView = (blob?: string) => {
  if (!blob) return;
  if (isFlutterWebView()) {
    window.flutter_inappwebview.callHandler(downloadFileHandler, blob);
  }

  if (isReactNativeWebView()) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: downloadFileHandler,
        url: blob,
      }),
    );
  }
};

// data is a stringified JSON object of ShareData interface
export const shareFileInFlutterSDK = (data?: string) => {
  if (!data) return;
  if (isFlutterWebView()) {
    window.flutter_inappwebview.callHandler(shareFileHandler, data);
  }
};

// The page events are sent to flutter app to handle the them on app side.
// Flutter SDK: https://github.com/unify-apps/unifyapps_flutter_sdk
const pageEventsHandlerInFlutterSDK = (event?: string) => {
  if (!event) return;
  window.flutter_inappwebview.callHandler(pageEventsHandler, event);
};

const pageEventsHandlerInReactNativeWebView = (event?: string) => {
  if (!event) return;
  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: pageEventsHandler,
      data: event,
    }),
  );
};

export const propagateEventsToWebview = <T>(event: T) => {
  if (typeof window === 'undefined') return;

  // This is a custom property added by the flutter sdk.
  if (isFlutterWebView() || typeof window?.flutter_inappwebview?.callHandler === 'function') {
    pageEventsHandlerInFlutterSDK(JSON.stringify(event));
  }

  if (isReactNativeWebView() || typeof window?.ReactNativeWebView?.postMessage === 'function') {
    pageEventsHandlerInReactNativeWebView(JSON.stringify(event));
  }
};
